import { Row } from "@commonlibs";
import styled, { css } from "styled-components";

export const SupportButtonsRoot = styled(Row)(
    ({ theme }) => css`
        column-gap: ${theme.spacing["3"]};
    `,
);

export const SupportButtonsIcon = styled.div(
    () => css`
        font-size: 1.5rem;
        cursor: pointer;
    `,
);
